import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Tennisvereniging app</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Tennisvereniging-app voor spelers: één plek voor alles</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">Leden van tennisverenigingen verwachten in 2026 één ding: <strong>één app</strong> die alles regelt rond husselen, tossen en racket trekken. Geen briefjes, geen bellen met de husselaar, geen "wie speelt zo waar?". De Hussel App biedt precies dat — voor zowel beheerders als spelers.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat ziet een speler in de app?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Overzicht van aankomende sessies.</li><li>Aanmelden of afmelden met één tik.</li><li>Live indeling: op welke baan speel ik en met wie?</li><li>Push-meldingen bij start van een nieuwe ronde.</li><li>Historie: hoe vaak heb ik gespeeld, tegen wie?</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Geen installatie nodig</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>De Hussel App werkt als <strong>PWA (Progressive Web App)</strong>: spelers openen een link in hun browser en kunnen direct meedoen. Optioneel kunnen ze de app aan hun home-screen toevoegen — dan voelt het als een echte app, zonder via een App Store te hoeven.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat ziet een beheerder?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Sessies aanmaken en beheren.</li><li>Live aanwezigheidslijst.</li><li>Statistieken per sessie en per speler.</li><li>Ledenbeheer (uitnodigen, rollen toewijzen).</li><li>Push-meldingen versturen.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Voor welke verenigingen?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Geschikt voor zowel kleine clubs (≤150 leden) als grote verenigingen (450+). Werkt voor tennis én padel. <a href="/club-register" class="text-accent hover:underline">Registreer je club</a> in minder dan 5 minuten.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Moeten leden iets installeren?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Nee. De app werkt in de browser. Optioneel kunnen leden de PWA op hun home-screen plaatsen.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Werkt het op iPhone en Android?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. De app werkt op iedere moderne smartphone met een browser — geen App Store nodig.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoe regel je rollen en rechten?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Er zijn vier rollen: super-admin, club-beheerder, husselaar en speler. Beheerders kunnen rollen toewijzen via het ledenoverzicht.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Krijgen leden ook push-meldingen?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja, als ze die toestaan. Meldingen worden gestuurd bij de start van een sessie, een nieuwe ronde of een wijziging.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Wat kost het?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Vanaf €19,95 per maand (excl. BTW) voor clubs tot 150 leden. Onbeperkt leden, sessies en meldingen inclusief.</div>
    </details></div>
    </div>
  </section>`;

const TennisverenigingAppSpelers = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default TennisverenigingAppSpelers;
